<script setup lang="ts">
import { computed } from "vue";

import BaseIframeModal from "@/components/BaseIframeModal.vue";
import type { Organisation, Questionnaire } from "@/types";

const { organisation, questionnaireId } = defineProps<{
  organisation: Organisation;
  questionnaireId?: Questionnaire["id"];
}>();

const src = computed(() => {
  const path = `/organisations/${organisation.id}`;

  if (!questionnaireId) {
    return path;
  }

  return `${path}?${new URLSearchParams({ questionnaire_id: questionnaireId })}`;
});

const modalTitle = computed(() => {
  if (organisation.topParentName) {
    return `${organisation.topParentName} - ${organisation.name}`;
  }

  return organisation.name;
});
</script>

<template>
  <BaseIframeModal
    size="xl"
    min-height="500px"
    fullscreen="lg-down"
    is-centered
    :title="modalTitle"
    :src
  />
</template>
